module.exports = __webpack_public_path__ + "media/images/badge/hero-member_secondary-98acc47e2b600c5a3d2459c99ddff4e8.png";